if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
     constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section) return;
          this.filterMediaByColor(event.data.variant);
        });

        if (this.dataset.initialOptions) {
          this.filterMediaByColor({ options: this.dataset.initialOptions.split('|') });
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

    removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

     filterMediaByColor(variant) {
        if (!variant || !variant.options) return;

        const colorIndex = parseInt(this.dataset.colorOptionIndex, 10);
        if (isNaN(colorIndex) || colorIndex < 0) return;

        const colorValue = (variant.options[colorIndex] || '').toLowerCase().trim();
        if (!colorValue) return;
        // this is old code 
        // const applyFilter = (list, selector) => {
        //   if (!list) return;
        //   list.querySelectorAll(selector).forEach((item) => {
        //     const alt = (item.dataset.mediaAlt || '').toLowerCase().trim();
        //     if (alt === '') {
        //       item.classList.remove('hidden');
        //       return;
        //     }
        //     // alt text ko words mein todo (comma, space, punctuation se) aur exact match dhoondo
        //     const words = alt.split(/[^a-z0-9]+/).filter(Boolean);
        //     const colorWords = colorValue.split(/[^a-z0-9]+/).filter(Boolean);
        //     const matches = colorWords.every((cw) => words.includes(cw));
        //     item.classList.toggle('hidden', !matches);
        //   });
        // };

                const normalize = (str) =>
          str
            .split(/[^a-z0-9]+/)
            .filter(Boolean)
            .sort()
            .join(' ');

        const normalizedColor = normalize(colorValue);

        const applyFilter = (list, selector) => {
          if (!list) return;
          list.querySelectorAll(selector).forEach((item) => {
            const alt = (item.dataset.mediaAlt || '').toLowerCase().trim();
            if (alt === '') {
              item.classList.remove('hidden');
              return;
            }
            const matches = normalize(alt) === normalizedColor;
            item.classList.toggle('hidden', !matches);
          });
        };
        applyFilter(this.elements.viewer, '[data-media-id]');
        applyFilter(this.elements.thumbnails, '[data-target]');

        const activeItem = this.elements.viewer.querySelector('[data-media-id].is-active');
        if (activeItem && activeItem.classList.contains('hidden')) {
          const firstVisible = this.elements.viewer.querySelector('[data-media-id]:not(.hidden)');
          if (firstVisible) this.setActiveMedia(firstVisible.dataset.mediaId, false);
        }
      }
    }
  );
}
